module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-menu"
  }, [_c('v-toolbar', {
    staticClass: "tab-container",
    class: {
      __absolute: _vm.absolute
    },
    attrs: {
      "app": "",
      "fixed": !_vm.absolute,
      "flat": _vm.absolute,
      "height": _vm.height
    }
  }, [_vm._t("topHeader")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e53a8e8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contentTopHeader.vue
// module id = 1798
// module chunks = 180